import React from 'react';
import './Gallery.css'; // Make sure to import the CSS file

const Gallery = () => {
  // Import the images properly using require or import
  const imageSrc = require('./bg1.jpg'); // Adjust the path based on the location of your image

  return (
    <section id="Gallery" className="gallery-section">
      <h2 className="about-title">Gallery</h2> 
      <div className="gallery-container">
        <div className="gallery-row">
          {/* Column 1 */}
          <div className="gallery-column">
            <img src={imageSrc} className="gallery-image" alt="Image 1" />
          </div>

          {/* Column 2 */}
          <div className="gallery-column">
            <img src={imageSrc} className="gallery-image" alt="Image 2" />
            <img src={imageSrc} className="gallery-image margin-top" alt="Image 3" />
          </div>

          {/* Column 3 */}
          <div className="gallery-column">
            <img src={imageSrc} className="gallery-image" alt="Image 4" />
            <img src={imageSrc} className="gallery-image margin-top float-right" alt="Image 5" />
          </div>

          {/* Column 4 */}
          <div className="gallery-column">
            <img src={imageSrc} className="gallery-image" alt="Image 6" />
          </div>

          {/* Column 5 */}
          <div className="gallery-column">
            <img src={imageSrc} className="gallery-image" alt="Image 7" />
            <img src={imageSrc} className="gallery-image margin-top" alt="Image 8" />
          </div>

          {/* Column 6 */}
          <div className="gallery-column">
            <img src={imageSrc} className="gallery-image" alt="Image 9" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
